import { auth } from '../firebase';
import { env } from '../config/environment';

async function postVoiceCallAction(url, body) {
  const idToken = await auth.currentUser?.getIdToken();
  if (!idToken) return null;

  const response = await fetch(url, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${idToken}`,
    },
    body: JSON.stringify(body),
  });

  if (!response.ok) {
    return null;
  }

  try {
    return await response.json();
  } catch {
    return null;
  }
}

export function finalizeCallLogForClient(clientId) {
  if (!clientId) return Promise.resolve(null);
  return postVoiceCallAction(env.apiEndpoints.voiceCallFinalize, { clientId });
}

/** Finalize by client, call log id, or active server session (free-dial / unlinked). */
export function finalizeActiveCallLog({ clientId = null, callLogId = null } = {}) {
  if (!clientId && !callLogId) {
    return postVoiceCallAction(env.apiEndpoints.voiceCallFinalize, {});
  }
  return postVoiceCallAction(env.apiEndpoints.voiceCallFinalize, {
    ...(clientId ? { clientId } : {}),
    ...(callLogId ? { callLogId } : {}),
  });
}

export function repairStaleCallLogsForClient(clientId) {
  if (!clientId) return Promise.resolve(null);
  return postVoiceCallAction(env.apiEndpoints.voiceCallRepairStale, { clientId });
}
